import { useEffect } from "react";
import { useDispatch } from "react-redux";

import ErrorBoundary from "@/app/shared/ErrorBoundary";
import { HELP_LIBRARY } from "@/constants/HelpUrls";
import Page from "@/design/layouts/Page";
import { setHelpUrl } from "@/store/reducers/ui";

import MediaDetails from "./MediaDetails";
import MediaList from "./MediaList";

export default function Library() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_LIBRARY));
  }, [dispatch]);

  return (
    <Page maxWidth="xxl">
      <MediaList />
      <ErrorBoundary>
        <MediaDetails />
      </ErrorBoundary>
    </Page>
  );
}
